/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import Image_User from "../../images/Iosif_Mikhelashvili.jpg";
import Image_Background from "../../images/background_image.jpg";
import makeFriendly from "../../modules/friendlyNumber";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import { getSectionTitle, setBackButtonShow } from "../../redux/actions/actions.js";
import Profile_Posts from "./Profile_Posts";
import React from "react";

const Profile = (props) => {
    const [followers,setFollowers] = useState("");
    const [following,setFollowing] = useState("");
    const {id,firstName,lastName,userName,description,birthday,registration} = props.user;
    const navigate = useNavigate();
    
    useEffect(() => {
        props.onGetSectionTitle("Profile");
        getNumberFollowers(id);
        getNumberFollowing(id);
    },[]);
    const getNumberFollowers = (id) => {
        fetch(`/follow/number?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setFollowers(data)
        })
        .catch(error => console.log(error))
    }
    const getNumberFollowing = (id) => {
        fetch(`/follow/numberfollowing?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setFollowing(data)
        })
        .catch(error => console.log(error))
    }
    const navToCustomize = () => {
        navigate("/profile/customize");
        props.onSetBackButtonShow("show");
    };
    const navToEdit = () => {
        navigate("/profile/edit");
        props.onSetBackButtonShow("show");
    }
    return(
        <div className="main_content_section_main">
            <div className="profile_header">
                <div className="profile_background_div">
                    <img className="profile_user_background" src={Image_Background} alt="User background" />
                </div>
                <img className="profile_user_image" src={Image_User} alt="User" />
                <button onClick={navToCustomize} className="profile_button profile_button_customize">Customize</button>
                <button onClick={navToEdit} className="profile_button profile_button_edit">Edit profile</button>
            </div>
            <div className={`main_content_section main_content_section_${props.color_background} profile_info`}>
                <div className="profile_user_name">{firstName} {lastName}</div>
                <div className="profile_user_username">@{userName}</div>
                <div className="profile_user_description">{description}</div>
                <div className="profile_user_dates">
                    <div className="profile_user_dates_birth profile_user_dates_div">
                        <i className="fa-solid fa-cake-candles profile_user_dates_icons"></i>
                        <div className="profile_user_dates_spans">
                            <span className="profile_user_dates_text">Born </span>
                            <span className="profile_user_dates_date">{birthday}</span>
                        </div>
                    </div>
                    <div className="profile_user_dates_registration profile_user_dates_div">
                        <i className="fa-solid fa-calendar-days profile_user_dates_icons"></i>
                        <div className="profile_user_dates_spans">
                            <span className="profile_user_dates_text">Joined </span>
                            <span className="profile_user_dates_date">{registration}</span>
                        </div>
                    </div>
                </div>
                <div className="profile_user_follow">
                    <div className="profile_user_follow_following profile_user_follow_div"><span className="profile_user_follow_number">{makeFriendly(following)}</span> <span className="profile_user_follow_text">Following</span></div>
                    <div className="profile_user_follow_followers profile_user_follow_div"><span className="profile_user_follow_number">{makeFriendly(followers)}</span> <span className="profile_user_follow_text">Followers</span></div>
                </div>
            </div>
            <Profile_Posts id={id} />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetSectionTitle: (text) => dispatch(getSectionTitle(text)),
        onSetBackButtonShow: (text) => dispatch(setBackButtonShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile);
